module.exports = __webpack_public_path__ + "static/tv-9cc265ab2e0c30b72da8c60e679876cc.png";